export default {
  title: '! Ordini in pausa fino alle {{time}}',
  button: 'Riprendi',
  labels: {
    rest_of_day: 'resto della giornata',
  },
};
